module.exports = __webpack_public_path__ + "img/side-icon-13-off.880a985f.svg";